import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPelicanComponent } from './simple-icons-pelican.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPelicanComponent ],
    exports:      [ SimpleIconsPelicanComponent ],
    bootstrap:    []
})
export class SimpleIconsPelicanModule {}
